import GoTagihan from "public/static/images/png/mitra/GoTagihan.png";
import Ayopop from "public/static/images/png/ic_paymentchannel_ayopop.png";
import LinkAja from "public/static/images/png/mitra/linkaja.png";
import OVO from "public/static/images/png/mitra/ovo.png";
import Dana from "public/static/images/png/mitra/dana.png";

export const ElectronicMoneyData = [
  {
    icon: GoTagihan,
    title: "Go Tagihan",
    sections: [
      {
        title: `Pembayaran melalui GoTagihan`,
        steps: [
          `Pada aplikasi Gojek pilih menu <b>GoTagihan</b>`,
          `Kemudian pilih menu <b>MULTIFINANCE</b>`,
          `Pilih <b>HOME CREDIT</b>`,
          `Masukkan <b>NOMOR KONTRAK</b> untuk melihat <b>RINCIAN TAGIHAN</b>`,
          `Kemudian klik <b>NEXT</b>`,
          `Pastikan data yang muncul adalah data kamu`,
          `Klik <b>PAY</b> untuk melanjutkan proses pembayaran`,
          `Kemudian diikuti dengan memasukkan <b>PIN GO-PAY</b>`,
          `Jika pembayaran berhasil, akan muncul halaman pemberitahuan`,
          `Transaksi selesai. Simpan bukti pembayaran kamu`,
          `Saldo <b>GO-PAY</b> kamu akan berkurang sesuai nominal yang dibayarkan`,
        ],
      },
    ],
  },
  {
    icon: Ayopop,
    title: "ayopop",
    sections: [
      {
        title: `Pembayaran melalui Ayopop`,
        steps: [
          `Buka aplikasi Ayopop kamu. Pada Home Screen Aplikasi Ayopop, klik produk <b>PEMBAYARAN ANGSURAN</b>`,
          `Pilih <b>HOME CREDIT</b>, dan masukkan <b>NOMOR KONTRAK</b>. Setelah itu, klik <b>CEK TAGIHAN</b>`,
          `Setelah itu, kamu akan melihat tampilan <b>INFORMASI TAGIHAN</b>, Cek kembali detail tagihan pembayaran kamu dengan Jenis Tagihan <b>INSTALLMENT</b>`,
          `Setalah itu, silahkan masukkan Nominal yang ingin kamu bayarkan dan klik <b>LANJUT KE PEMBAYARAN</b>, dan pilih metode pembayaran yang kamu mau`,
          `Setelah pembayaran sukses, akan keluar <b>INVOICE</b> beserta dengan detail  pembayaran kamu`,
        ],
      },
    ],
  },
  {
    icon: LinkAja,
    title: "LinkAja",
    sections: [
      {
        title: `Pembayaran melalui Link Aja`,
        steps: [
          `Buka aplikasi Link Aja`,
          `Pilih SEMUA pada Home Page`,
          `Pilih MULTI FINANCE`,
          `Pilih BAYAR TAGIHAN`,
          `Pilih HOME CREDIT INDONESIA`,
          `Masukkan nomor kontrak kamu, pilih LANJUT`,
          `Cek ulang detail data dan tagihan cicilan kamu, pilih KONFIRMASI jika benar`,
          `Masukkan PIN Link Aja untuk melakukan pembayaran`,
        ],
      },
    ],
  },
  {
    icon: OVO,
    title: "OVO",
    sections: [
      {
        title: `Pembayaran melalui OVO`,
        steps: [
          `Buka aplikasi OVO`,
          `Pilih <b>ANGSURAN KREDIT</b> pada homepage OVO`,
          `Pilih <b>HOME CREDIT INDONESIA</b>`,
          `Masukkan 10 digit <b>NOMOR KONTRAK</b> pada nomor pelanggan, kemudian klik <b>LANJUT KE PEMBAYARAN</b>`,
          `Muncul halaman konfirmasi yang berisi <b>INFORMASI PELANGGAN</b>, <b>JUMLAH PEMBAYARAN</b>. Pastikan nomor kontrak, nama, dan nominal pembayaran sudah sesuai kemudian klik <b>KONFIRMASI</b>`,
          `Pilih metode pembayaran <b>OVO CASH</b> pelanggan juga dapat menggunakan promo dan voucher yang tersedia (jika ada) dan Pilih <b>BAYAR</b>`,
          `Masukkan <b>PIN OVO</b> untuk melakukan pembayaran.`,
          `Pelanggan mendapatkan notifikasi jika proses pembayaran berhasil`,
        ],
      },
    ],
  },
  {
    icon: Dana,
    title: "Dana",
    sections: [
      {
        title: `Pembayaran melalui Dana`,
        steps: [
          `Buka aplikasi DANA`,
          `Pilih <b>SEMUA</b> pada homepage DANA`,
          `Pilih <b>INSTALLMENT</b> pada menu Bills`,
          `Pilih <b>HOME CREDIT INDONESIA</b>`,
          `Pelanggan juga dapat mencari Home Credit Indonesia pada search bar`,
          `Masukkan <b>NOMOR KONTRAK</b> dan klik <b>CHECK BILL</b>`,
          `Cek ulang detail data dan tagihan kemudian. Pilih <b>CONFIRM</b> jika benar`,
          `Muncul <b>PAYMENT CONFIRMATION</b>, pastikan nominal dan nomor kontrak yang akan dibayarkan sudah sesuai kemudian pilih metode pembayaran <b>DANA BALANCE</b> kemudian klik <b>PAY</b> jika benar`,
          `Masukkan <b>PIN DANA</b> untuk melakukan pembayaran.`,
          `Pelanggan mendapatkan notifikasi jika proses pembayaran berhasil`,
        ],
      },
    ],
  },
];
